import React from "react";
import Navbar from "../../Components/Layout/Navbar";
import Footer from "../../Components/Layout/Footer";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Phone } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";

const NonAuthLayout = (props) => {
  const location = useLocation();
  useEffect(() => {
    console.log("I am running");
    window.scrollTo(600, 0);
    AOS.init({
      offset: 100,
      duration: 1000,
      easing: "ease-in-out",
      delay: 50,


    });

  }, [location.pathname]);
  return (
    <React.Fragment>
      <Navbar />
      {props.children}
      <Footer />
      <div className="fixed bottom-20 right-4 z-40 flex flex-col gap-3 md:right-8">
        <a
          href="tel:+918249686752"
          aria-label="Call Go Cabz"
          title="Call Go Cabz"
          className="flex h-14 w-14 items-center justify-center rounded-full bg-[#0E5A00] text-white shadow-lg transition-transform hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0E5A00] cursor-pointer"
        >
          <Phone size={24} aria-hidden="true" />
        </a>
        <a
          href="https://wa.me/918249686752"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat with Go Cabz on WhatsApp"
          title="Chat on WhatsApp"
          className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#25D366]"
        >
          <FaWhatsapp size={28} aria-hidden="true" />
        </a>
      </div>
    </React.Fragment>
  );
};

export default NonAuthLayout;
